import React, { useEffect, useState } from 'react'
import { NavLink, useParams } from 'react-router-dom';
import Popupform from '../Popupform/Popupform';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import config from '../../config/config';
import Boucherpopup from '../Popupform/Boucherpopup';


const StudyGoalColleges = () => {

    const location = useLocation();
    const { courseName, state } = location.state || {};

    const querydata = {
        courseName,
        state
    }

    console.log("querydata", querydata);

    const [tableData, setTableData] = useState([]);


    useEffect(() => {
        const fetchCollegeData = async () => {
            try {
                console.log("req.query", querydata);
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_navSelectGoalCOllages`, {
                    params: querydata
                });
                console.log("response", response.data)
                const fetchedData = response.data.collegesByCourseName || [];
                setTableData(fetchedData);
                console.log("fetchedData", fetchedData); // Log for debugging
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };

        fetchCollegeData();
    }, []);

    const [showPopup, setShowPopup] = useState(false);

    const handleOpenPopup = () => setShowPopup(true);
    const handleClosePopup = () => setShowPopup(false);




    // Download boucher 

    const [showBoucherPopup, setShowBoucherPopup] = useState(false);

    const handleOpenBoucherPopup = () => setShowBoucherPopup(true);
    const handleCloseBoucherPopup = () => setShowBoucherPopup(false);
    return (
        <div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col p-0 m-0">
                        <div className='background_banner contact_banner'>
                            <h2>Colleges in {state} </h2>
                            <p>Looking for the perfect city to pursue your dreams? Explore the top study destinations in India, known for their <br /> prestigious universities, world-class faculty, and excellent career opportunities.</p>
                        </div>
                    </div>
                </div>
            </div>



            {/* Table  */}
            <div className="container mt-5">
                <div className="row">
                    <div className="col">
                        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                            {/* Desktop Header */}
                            <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 text-xs font-bold text-gray-400 uppercase tracking-wider bg-gray-50">
                                <div className="col-span-1 text-center">Rank</div>
                                <div className="col-span-6">College Info</div>
                                <div className="col-span-2">Fees</div>
                                <div className="col-span-3">Placement</div>
                            </div>

                            {tableData.length > 0 ? (
                                tableData.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {/* Mobile Card View */}
                                        <div className="md:hidden bg-white border-b border-gray-100 last:border-0 p-5 relative">
                                            <div className="flex items-start gap-4 mb-4">
                                                <div className="absolute top-0 left-0 bg-yellow-400 text-white text-[10px] font-bold px-3 py-1 rounded-br-lg shadow-sm z-10">
                                                    #{item.rank}
                                                </div>

                                                <div className="mt-6 flex-1">
                                                    <NavLink
                                                        to={`/college/${item._id}`}
                                                        className="font-bold text-gray-900 leading-tight text-lg block mb-1 hover:text-brand-orange no-underline"
                                                    >
                                                        {item.collegeName}
                                                    </NavLink>
                                                    <div className="flex items-center text-xs text-gray-500 mb-2">
                                                        <i className="fa fa-map-marker mr-1"></i> {item.city}
                                                    </div>
                                                    <p className="text-xs text-gray-400 mb-3 line-clamp-2">{item.subheading}</p>
                                                </div>
                                            </div>

                                            {/* Details Grid */}
                                            <div className="grid grid-cols-2 gap-4 border-t border-gray-50 pt-3 mb-4">
                                                <div>
                                                    <p className="text-[10px] text-gray-400 uppercase font-bold">Fees</p>
                                                    <p className="text-sm font-bold text-gray-800">₹ {item.fee}</p>
                                                </div>
                                                <div>
                                                    <p className="text-[10px] text-gray-400 uppercase font-bold">Avg Placement</p>
                                                    <p className="text-sm font-bold text-green-600">₹ {item.placementavg}</p>
                                                </div>
                                                <div className="col-span-2 border-t border-gray-50 pt-2 mt-2">
                                                    <p className="text-[10px] text-gray-400 uppercase font-bold">Highest Placement</p>
                                                    <p className="text-xs font-bold text-gray-800">₹ {item.placementhig}</p>
                                                </div>
                                            </div>

                                            {/* Actions */}
                                            <div className="flex flex-col sm:flex-row gap-2">
                                                <button
                                                    onClick={handleOpenPopup}
                                                    className="flex-1 bg-brand-orange text-white text-sm font-bold py-3 rounded-lg hover:bg-orange-600 transition flex items-center justify-center border-0"
                                                >
                                                    Apply Now
                                                </button>
                                                <button
                                                    onClick={handleOpenBoucherPopup}
                                                    className="flex-1 bg-gray-50 text-gray-700 border border-gray-200 text-sm font-bold py-3 rounded-lg hover:bg-gray-100 transition flex items-center justify-center"
                                                >
                                                    Download Brochure
                                                </button>
                                            </div>
                                        </div>

                                        {/* Desktop Row View */}
                                        <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b last:border-0 border-gray-50 hover:bg-orange-50/30 transition items-center group">
                                            <div className="col-span-1 text-center font-bold text-gray-400 group-hover:text-brand-orange">
                                                #{item.rank}
                                            </div>
                                            <div className="col-span-6">
                                                <NavLink to={`/college/${item._id}`} className="text-lg font-bold text-gray-800 hover:text-brand-orange transition block mb-1 no-underline">
                                                    {item.collegeName}
                                                </NavLink>
                                                <div className="flex items-center text-xs text-gray-500 mb-1">
                                                    <span className="mr-1"><i className="fa fa-map-marker"></i></span> {item.city}
                                                </div>
                                                <p className="text-xs text-gray-400 mb-2">{item.subheading}</p>
                                                <div className="flex gap-4">
                                                    <button onClick={handleOpenPopup} className="text-xs font-bold text-brand-orange hover:underline flex items-center bg-transparent border-0 p-0">
                                                        Apply Now
                                                    </button>
                                                    <button onClick={handleOpenBoucherPopup} className="text-xs font-medium text-gray-500 hover:text-gray-800 flex items-center bg-transparent border-0 p-0">
                                                        Download Brochure
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-span-2 font-bold text-gray-800">
                                                ₹ {item.fee}
                                            </div>
                                            <div className="col-span-3">
                                                <div className="mb-1">
                                                    <span className="font-bold text-green-600">₹ {item.placementavg}</span>
                                                    <span className="text-[10px] text-gray-400 uppercase font-bold ml-1">Avg</span>
                                                </div>
                                                <div>
                                                    <span className="font-bold text-gray-800">₹ {item.placementhig}</span>
                                                    <span className="text-[10px] text-gray-400 uppercase font-bold ml-1">High</span>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))
                            ) : (
                                <div className="p-12 text-center text-gray-500">
                                    No colleges found.
                                </div>
                            )}
                        </div>
                        {/* Popup Modal */}
                        {showPopup && (
                            <div className="popup-overlay">
                                <div className="popup-content">
                                    <button className="close-btn" onClick={handleClosePopup}>
                                        &times;
                                    </button>
                                    <Popupform />
                                </div>
                            </div>
                        )}


                        {/* Boucher Popup */}
                        {showBoucherPopup && (
                            <div className="popup-overlay">
                                <div className="popup-content">
                                    <button className="close-btn" onClick={handleCloseBoucherPopup}>
                                        &times;
                                    </button>
                                    <Boucherpopup />
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>





        </div>
    )
}

export default StudyGoalColleges
